export default __webpack_public_path__ + "998626d71c0e5aca1e4881fda1a1e28d.png";